import Title from "./Title";
import { services } from "./Service";
const Services = () => {
  return (
    <>
      <section className='section services' id='services'>
        <Title Text1='our' Text2='services' />
        <div className='section-center services-center'>
          {services.map((service) => {
            const { id, icon, title, text } = service;
            return (
              <article className='service' key={id}>
                <span className='service-icon'>
                  <i className={icon}></i>
                </span>
                <div className='service-info'>
                  <h4 className='service-title'>{title}</h4>
                  <p className='service-text'>{text}</p>
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </>
  );
};
export default Services;
